/** Unidades de tempo para etapas/ciclos de produção. */

export const TEMPO_UNIDADES = [
  { value: 's', label: 'Segundos' },
  { value: 'min', label: 'Minutos' },
  { value: 'h', label: 'Horas' }
];

/**
 * @param {unknown} u
 * @returns {'s'|'min'|'h'}
 */
export function normalizeTempoUnidade(u) {
  const v = String(u || 'min').toLowerCase().trim();
  if (v === 's' || v === 'seg' || v === 'segundo' || v === 'segundos') return 's';
  if (v === 'h' || v === 'hora' || v === 'horas') return 'h';
  return 'min';
}

/**
 * Converte valor + unidade para minutos (base do timer / tempo_planejado).
 * @param {unknown} valor
 * @param {unknown} unidade
 * @returns {number|null}
 */
export function toMinutes(valor, unidade) {
  if (valor == null || valor === '') return null;
  const n = Number(valor);
  if (!Number.isFinite(n) || n <= 0) return null;
  const u = normalizeTempoUnidade(unidade);
  if (u === 's') return n / 60;
  if (u === 'h') return n * 60;
  return n;
}

/**
 * @param {unknown} u
 * @returns {string}
 */
export function labelTempoUnidade(u) {
  const n = normalizeTempoUnidade(u);
  if (n === 's') return 'segundos';
  if (n === 'h') return 'horas';
  return 'minutos';
}

/**
 * @param {unknown} u
 * @returns {string} sufixo curto (s / min / h)
 */
export function suffixTempoUnidade(u) {
  return normalizeTempoUnidade(u);
}

/**
 * Ex.: "15 min", "90 s", "2 h"
 * @param {unknown} valor
 * @param {unknown} unidade
 */
export function formatTempoEstimado(valor, unidade) {
  if (valor == null || valor === '') return '—';
  return `${valor} ${suffixTempoUnidade(unidade)}`;
}
